import { SUPPORTED_COUNTRIES, countryNameOf } from '../regions.js'

interface CountryInputProps {
  id?: string
  /** ISO 3166-1 alpha-2, as the address stores it. */
  value: string
  onChange: (country: string) => void
  className?: string
}

/**
 * An address's country. While the platform supports one country
 * (`SUPPORTED_COUNTRIES`, the countries whose regions are listed) it is
 * not a choice: the field shows that country's name, read only. Once a
 * second country is listed it becomes a choice between them, with no
 * change to the forms that use it.
 */
export function CountryInput({ id, value, onChange, className = '' }: CountryInputProps) {
  if (SUPPORTED_COUNTRIES.length <= 1) {
    return <input id={id} className={`${className} !bg-canvas !text-ink-mid cursor-default`} value={countryNameOf(value)} readOnly aria-readonly="true" title="The only country supported today" />
  }
  const options = SUPPORTED_COUNTRIES.includes(value) ? SUPPORTED_COUNTRIES : [value, ...SUPPORTED_COUNTRIES]
  return (
    <select id={id} className={className} value={value} autoComplete="country" onChange={(event) => onChange(event.target.value)}>
      {options.map((country) => (
        <option key={country} value={country}>
          {countryNameOf(country)}
        </option>
      ))}
    </select>
  )
}
